import React from "react"
import facebookGrey from "@images/icons/facebookGrey.svg"
// import whatsappGrey from '@images/icons/whatsappGrey.svg';
import linkedinGrey from "@images/icons/linkedInGrey.svg"
import twitterGrey from "@images/icons/twitterGrey.svg"
import * as styles from "./SocialShare.module.scss"

const SocialShare = (props) => (
  <div className={styles.SocialShare}>
    <a
      href={`https://www.facebook.com/sharer/sharer.php?u=${props.url}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={facebookGrey} alt="facebook" />
    </a>
    <a
      href={`https://twitter.com/home?status=${props.url}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={twitterGrey} alt="Twitter" />
    </a>
    {/* <a href={"whatsapp://send?text=" + props.url}><img src={whatsappGrey} alt="Whatsapp" /></a> */}
    <a
      href={`https://www.linkedin.com/shareArticle?mini=true&url=${props.url}&title=&summary=&source=`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={linkedinGrey} alt="linkedin" />
    </a>
  </div>
)

export default SocialShare
